import {ref} from 'vue';
import Pageable from '@/models/dto/filters/Pageable';

export default function usePageable() {
  const page = ref(0);
  const size = ref(100);
  const sortField = ref('');
  const sortOrder = ref(1);

  /**
   *
   * @return {Pageable} les paramètres de pagination
   */
  function getQueryParams(sizeValue) {
    if(sizeValue === undefined){
      sizeValue = size.value;
    }
    const field = sortField.value || '';
    const direction = sortOrder.value === 1 ? 'asc' : 'desc';
    return new Pageable({
      page: page.value,
      size: sizeValue,
      sort: `${field},${direction}`,
    });
  }

  return {
    page,
    size,
    sortField,
    sortOrder,
    getQueryParams,
  }
}
